
export class SubjectEntity {
  id: number;
  alias: string;
  name: string;
  icon: string;
}
